import { useEffect } from "react";
import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import DynamicTable from "src/components/table";
import {
    columntype,
    dataLocalStorage,
    getLocalStorage,
    inputType,
    isValidArray,
} from "src/helper/publicFunction";
import { ManageMedia, DeleteMedia, EditMedia, GetMedia } from "./actions";
import DynamicModal from "src/components/modal/DynamicModal";
import * as Yup from "yup";
import { CommonAlert } from "src/components/alert/CommonAlert";
import { Button } from "@mui/material";
import { IconArrowLeft } from "@tabler/icons";

const Media = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { type, related_id } = useParams();
    const Commonalert = CommonAlert();
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);
    const [loadingData, setLoadingData] = useState(true);
    const [loadingEditdatatype, setloadingEditdatatype] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [array, setarray] = useState([]);
    const [values, setvalues] = useState({});
    const [editMode, setEditMode] = useState(false);
    const [data, setData] = useState([]);
    const [TotalData, setTotalData] = useState(0);
    const [selected, setSelected] = useState([]);


    const Schema = Yup.object().shape({
        link: Yup.mixed().required("Media file is required"),
    });

    const GetData = () => {
        setLoadingData(true);

        console.log('🔍 GetData called with:', { type, related_id });

        dispatch(
            GetMedia({
                type,
                related_id,
                callback: (responseData) => {
                    console.log('🔍 GetMedia API Response:', responseData);
                    console.log('🔍 Response data field:', responseData?.data);
                    console.log('🔍 Response data type:', typeof responseData?.data);
                    console.log('🔍 Response data is array:', Array.isArray(responseData?.data));
                    console.log('🔍 isValidArray result:', isValidArray(responseData?.data));

                    if (isValidArray(responseData?.data)) {
                        console.log('✅ Setting data to:', responseData.data);
                        setData(responseData.data);
                        setTotalData(responseData.data.length);
                    } else {
                        console.log('❌ Data is not valid array, setting empty array');
                        console.log('🔍 What isValidArray received:', responseData?.data);
                        setData([]);
                        setTotalData(0);
                    }

                    // Form fields initialization
                    if (array.length === 0) {
                        setarray([
                            {
                                failed: "id",
                                type: inputType.text,
                                title: "id",
                                placeholder: "",
                                fullwidth: true,
                                customdesign: { display: "none" },
                            },
                            {
                                failed: "link",
                                type: inputType.image,
                                title: "Media File",
                                placeholder: "Upload media",
                                fullwidth: true,
                                customdesign: { width: "100%" },
                            },
                            {
                                failed: "type",
                                type: inputType.text,
                                title: "Type",
                                placeholder: "",
                                fullwidth: true,
                                customdesign: { display: "none" },
                            },
                            {
                                failed: "related_id",
                                type: inputType.text,
                                title: "Related ID",
                                placeholder: "",
                                fullwidth: true,
                                customdesign: { display: "none" },
                            },
                        ]);
                    }
                    setLoadingData(false);
                },
                onError: (error) => {
                    console.error('❌ GetMedia API Error:', error);
                    setData([]);
                    setTotalData(0);
                    setLoadingData(false);
                }
            })
        );
    };

    useEffect(() => {
        GetData({ tableName: null, type: null });
    }, [type, related_id]);

    const columns = [
        { type: columntype.text, name: "id" },
        {
            type: columntype.image,
            name: "link",
            options: { width: 100, height: 100 }
        },
        { type: columntype.text, name: "type" },
        { type: columntype.text, name: "related_name" },
    ];

    const headCells = [
        { id: "id", numeric: false, disablePadding: false, label: "ID", withSort: true },
        { id: "link", numeric: false, disablePadding: false, label: "Media", withSort: false },
        { id: "type", numeric: false, disablePadding: false, label: "Type", withSort: false },
        
        { id: "related_name", numeric: false, disablePadding: false, label: "Service/Project", withSort: false },
        {
            id: "action",
            numeric: false,
            disablePadding: false,
            label: "Actions",
            withSort: false,
        },
    ];

    const List = [
        {
            name: "Delete",
            function: async (row) => {
                Commonalert.show({
                    title: `Delete this media?`,
                    message: "You won't be able to revert this!",
                    type: "delete",
                    actions: [
                        {
                            name: "Yes",
                            callback: () =>
                                dispatch(
                                    DeleteMedia({
                                        callback: GetData,
                                        id: [row?.id],
                                    })
                                ),
                            type: "delete",
                        },
                        { name: "No", callback: () => { }, type: "cancel" },
                    ],
                });
            },
        },
        {
            name: "Edit",
            function: async (data) => {
                setEditMode(true);
                setvalues(data);
                setShowModal(true);
            },
        },
    ];

    const updateDataApi = ({ row, failedName, newData }) => {
        setloadingEditdatatype(`${row?.id}-${failedName}`);
        dispatch(
            EditMedia({
                id: row?.id,
                dataFailed: newData,
                nameFailed: failedName,
                callback: () => {
                    GetData();
                },
            })
        );
    };
    console.log('Media component render - data:', data, 'type:', typeof data, 'isArray:', Array.isArray(data));
    return (
        <div>
            <Button
                startIcon={<IconArrowLeft />}
                onClick={() => navigate(-1)}
                sx={{ mb: 2 }}
            >
                Back to {type === 'service' ? 'Services' : 'Projects'}
            </Button>

            <DynamicTable
                onPressDelete={(ListIds) => {
                    Commonalert.show({
                        title: "Confirm Delete",
                        message: `You won't be able to revert this!`,
                        type: "delete",
                        actions: [
                            {
                                name: "Yes",
                                callback: () =>
                                    dispatch(
                                        DeleteMedia({
                                            callback: GetData,
                                            id: ListIds,
                                        })
                                    ),
                                type: "delete",
                            },
                            { name: "No", callback: () => { }, type: "cancel" },
                        ],
                    });
                }}
                onPressAdd={() => {
                    setvalues({ type, related_id });
                    setEditMode(false);
                    setShowModal(true);
                }}
                items={Array.isArray(data) ? data : []}
                columns={columns}
                headCells={headCells}
                page={page}
                setPage={setPage}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={setRowsPerPage}
                Listdropdown={List}
                withOption={true}
                loadingData={loadingData}
                selected={selected} // selected items
                setSelected={setSelected} // set selected items
                rowsPerPageOptions={[5, 10, 25, 50]}
                totalItem={TotalData || 0} // Ensure it's always a number
                loadingEditdatatype={loadingEditdatatype}
                withAddButton={true}
                withDeleteItem={true}
                withEditItem={true}
                withPagination={false}
                withSearch={false}
                title={`${type.charAt(0).toUpperCase() + type.slice(1)} Media`}
            />

            {showModal && (
                <DynamicModal
                    show={showModal}
                    setShow={setShowModal}
                    faileds={array}
                    values={values}
                    title={"Media"}
                    editMode={editMode}
                    description={editMode ? "Edit Media" : "Add New Media"}
                    buttonTitle={editMode ? "Update" : "Create"}
                    onSubmit={(values) => {
                        dispatch(
                            ManageMedia({
                                editMode,
                                values,
                                callback: (res) => {
                                    if (res) {
                                        setShowModal(false);
                                        GetData();
                                    }
                                },
                            })
                        );
                    }}
                    Schema={Schema}
                />
            )}
        </div>
    );
};

export default Media;